// Event delegation for multiple modals
const modal = document.querySelector('.easysearch-modal');
if (window.innerWidth < 1000) {
    document.body.append(modal);
}
document.addEventListener('click', function(e) {
    // Open modal
    if (e.target.closest('.easy-search-modal-btn')) {
        const btn = e.target.closest('.easy-search-modal-btn');
        modal.style.display = 'flex';
        setTimeout(() => {
            modal.classList.add('active');
        }, 10);
    }

    // Close modal
    if (e.target.closest('.easysearch-close-btn')) {
        
        const closeBtn = e.target.closest('.easysearch-close-btn');
        // Find the closest modal ancestor
        const modal = closeBtn.closest('.easysearch-modal');
        modal.classList.remove('active');
        modal.addEventListener('transitionend', function handler() {
            modal.style.display = 'none';
            modal.removeEventListener('transitionend', handler);
        });
    }
});